export default "__VITE_ASSET__Cx0ocfxN__"